// extracted by mini-css-extract-plugin
export default {"toast":"download_toast_toast__bzFLY","slideIn":"download_toast_slideIn__zdXjK","link":"download_toast_link__Hi-gT"};